<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0">
      <div class="p-3">Customers</div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4 mb-5">
        <div class="table-responsive">
          <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
            [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Customer Details</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
  </div>
  <div class="modal-body">
    @if (selectedCustomer && customerData) {
      <div class="container-fluid">
        <div class="row pt-2">
          <div class="col-md-3">
            Customer Name
          </div>
          <div class="col-md-9">
            : {{ selectedCustomer.customerId.name }}
          </div>
          <div class="col-md-3">
            Email Id
          </div>
          <div class="col-md-9">
            : {{ selectedCustomer.customerId.emailId }}
          </div>
          <div class="col-md-3">
            Mobile
          </div>
          <div class="col-md-9">
            : {{ selectedCustomer.customerId.mobile }}
          </div>
          <div class="col-md-3">
            Country
          </div>
          <div class="col-md-9">
            : {{ selectedCustomer.customerId.country?.displayName }}
          </div>
          <div class="col-md-3">
            Account Status
          </div>
          <div class="col-md-9">
            : <span class="badge" [ngClass]="selectedCustomer.customerId.isFrozen ? 'bg-danger' : 'bg-success'">
            <i class="bi" [ngClass]="selectedCustomer.customerId.isFrozen ? 'bi-lock' : 'bi-check-circle'"></i>
            {{ selectedCustomer.customerId.isFrozen ? 'FROZEN' : 'ACTIVE' }}
          </span>
        </div>
        <div class="col-md-3">
          Created At
        </div>
        <div class="col-md-9">
          : {{ dateFormat(selectedCustomer.createdAt) }}
        </div>
        <h5 class="mt-2 btn btn-primary mt-3 text-start bg-primary-subtle text-primary border-0">KYC Details</h5>
        <div class="col-md-3">
          Driving Licence Number
        </div>
        <div class="col-md-9">
          : {{ customerData?.kyc?.drivingLicenceNumber }}
        </div>
        <div class="col-md-3">
          Passport Number
        </div>
        <div class="col-md-9">
          : {{ customerData?.kyc?.passportNumber }}
        </div>
        <h5 class="mt-2 btn btn-primary border-0 bg-primary-subtle text-primary mt-3 text-start">Documents</h5>
        <div class="col-md-3">
          Driving Licence
        </div>
        <div class="col-md-9">
          @if (customerData?.kyc?.drivingLicenceImage) {
            <button type="button"
              class="btn btn-sm btn-outline-primary"
              (click)="getImage(customerData?.kyc?.drivingLicenceImage)">
              <i class="bi bi-eye me-1"></i>
              View
            </button>
          }
          @if (!customerData?.kyc?.drivingLicenceImage) {
            <span>
              : Document is not available
            </span>
          }
        </div>
        <div class="col-md-3 mt-2 mb-2">
          Passport
        </div>
        <div class="col-md-9 mt-2 mb-2">
          @if (customerData?.kyc?.passportImage) {
            <button type="button"
              class="btn btn-sm btn-outline-primary" (click)="getImage(customerData?.kyc?.passportImage)">
              <i class="bi bi-eye me-1"></i>
              View
            </button>
          }
          @if (!customerData?.kyc?.passportImage) {
            <span>
              : Document is not available
            </span>
          }
        </div>
        <div class="col-md-3">
          Selfie
        </div>
        <div class="col-md-9">
          @if (customerData?.kyc?.selfieImage) {
            <button type="button" class="btn btn-sm btn-outline-primary"
              (click)="getImage(customerData?.kyc?.selfieImage)">
              <i class="bi bi-eye me-1"></i>
              View
            </button>
          }
          @if (!customerData?.kyc?.selfieImage) {
            <span>
              : Document is not available
            </span>
          }
        </div>
        <h5 class="mt-2 btn btn-primary mt-3 text-start bg-primary-subtle text-primary border-0">Account Details</h5>
        <div class="col-md-3">
          Account Name
        </div>
        <div class="col-md-9">
          : {{ customerData?.account?.partnerId?.name }}
        </div>
        <div class="col-md-3">
          Account Number
        </div>
        <div class="col-md-9">
          : {{ customerData?.account?.accountNumber }}
        </div>
        <div class="col-md-3">
          Routing Number
        </div>
        <div class="col-md-9">
          : {{ customerData?.account?.routingNumber }}
        </div>
      </div>
    </div>
  }
</div>
</ng-template>

